module.exports = "/src/views/donate/main/assets/images/menu/packages.png";